import { FormattedMessage } from 'react-intl';

export const EditAlert = () => (
    <div className='alert alert-info margin-bottom-15'>
        <div className='display-flex gap-10'>
            <span className='text-color-info text-size-h4 uikit-icon icon-info-sign' />
            <div>
                <FormattedMessage id='intl-msg:geofence.edit.text' />
            </div>
        </div>
    </div>
);
